module.exports = __webpack_public_path__ + "img/m_join_2.739f21ee.png";